<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
    <main class="page-content">
        <div class="bgColor">
            <div class="container">
                <div class="row align-items-center py-3">
          <div class="col-md-6">
            <p class="appTitle mb-0">Add Courses for College</p>
          </div>
          <div class="col-md-6 text-end">
            <div class="admin-info d-inline-flex align-items-center">
              <span class="adminName me-2">{{ adminName }}</span>
              <img width="36" height="36" src="assets/tenant-avatar.jpg" class="rounded-circle" alt="Admin" />
            </div>
          </div>
        </div>

              <div class="row my-3 align-items-center">
  <div class="col-md-6">
    <div class="search-wrapper position-relative">
      <input
        class="form-control search-input"
        (input)="onChangeEvent($event)"
        type="text"
        placeholder="🔍 Search College..."
        [(ngModel)]="searchval"
      />
      <button
        class="clear-btn"
        *ngIf="searchval"
        (click)="reset()"
        type="button"
        aria-label="Clear search"
      >
        ✖
      </button>
    </div>
  </div>

  <div class="col-md-6 text-end">
    <button
      type="button"
      class="btn btn-primary addCourseBtn"
      (click)="openAdd()"
    >
      <i class="fa fa-plus" aria-hidden="true"></i> Add Images
    </button>
  </div>
</div>

                <div *ngIf="showData">
                    <div class="displayImages" *ngFor="let image of allCollegeImages;let indexOfelement=index;">
                        <div class="row" style="margin-bottom: 0.7em; margin-top: 0.7em;">
                            <div class="col-md-6">
                                <h2>{{ image.college_name }}</h2>
                            </div>
                            <div class="col-md-6" style="text-align:right;">
                                <button type="button" class="btn btn-primary addCourseBtn" (click)="viewImages(indexOfelement)">View All</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3" *ngFor="let img of image.lessData" style="margin-bottom: 1em !important;">
                                <div class="img-wraps">
                                    <img class="clgImg" [src]="img.image">
                                    <i class="fa fa-trash-o closes" aria-hidden="true" (click)="deleteImage(img)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="noData" *ngIf="showNodata">
                    <h2>Currenly No Data Available!</h2>
                </div>
            </div>

            <div class="backdrop" [ngStyle]="{'display':display}"></div>
            <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header" *ngIf="showAdd">
                            Add Images
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="modal-header" *ngIf="showEdit">
                            Edit Images
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="dltmodal-content animate modal-body dltBl">
                            <form [formGroup]="collegeImagesForm">
                                <label>Select College</label>
                                <select class="form-control" formControlName="collegeName" [(ngModel)]="collegeId">
                                    <option *ngFor="let college of colleges;let x = index" [ngValue]="college.id">{{
                                        college.collage_name }}</option>
                                </select>
                                <div class="error-messages">
                                    <div *ngFor="let error of error_messages.collegeName">
                                        <div class="error-message" *ngIf="collegeImagesForm.get('collegeName').hasError(error.type) && (collegeImagesForm.get('collegeName').dirty || collegeImagesForm.get('collegeName').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>
                                </div>

                                <label class="uploadImage">Upload Image
                                    <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                                    <input type="file" formControlName="colgImg" (change)="handleFileInput($event)"
                                        multiple="" hidden>
                                </label>
                                <img class="multipleImg" width="80px" height="80px" *ngFor="let img of images" [src]="img">
                                <div class="error-messages">
                                    <div *ngFor="let error of error_messages.colgImg">
                                        <div class="error-message" *ngIf="collegeImagesForm.get('colgImg').hasError(error.type) && (collegeImagesForm.get('colgImg').dirty || collegeImagesForm.get('colgImg').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>
                                </div>

                                <div class="addBtn" *ngIf="showAdd">
                                    <button class="commonBtn mt-2" [disabled]="!collegeImagesForm.valid" (click)="addImages()">
                                        Add Images</button>
                                </div>
                                <div class="addBtn" *ngIf="showEdit">
                                    <button class="commonBtn mt-2"> Update</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
            <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
                            <p>Do you want to delete College Image ?</p>
                            <button type="submit" class="btn btn-success" (click)="delete()" style="width: 20%;">Yes</button>
                            <button type="submit" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%;margin-left: 0.3em;">No</button><br><br>
                            <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </main>
</div>